import ReactDOM from "react-dom";
import "./index.css";
import { Provider } from "react-redux";
import App from "./app/App";
import reportWebVitals from "./reportWebVitals";
import store from "./globalStore/store";

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
